import { Grid } from '@mui/joy';
import { Icon, Toolbar, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { endpoint } from '../../resource/Constant';
import './home.css';
import { origin } from '../../resource/Constant';

export default function ChatbotDocs() {
  const [adminWrapper, setAdminwrapper] = useState();
  const [chatWrapper, setChatwrapper] = useState();

  useEffect(() => {
    setAdminwrapper(
      `<div id="chatbot_div" class="frame-container resize-frame">
        <style>
            .frame-container {
                position: fixed;
                bottom: -30px;
                right: -25px;
            }
    
            .resize-frame {
                width: 120px;
                height: 120px;
                background-color: transparent;
            }
    
            .resize-frame:hover {
                width: 380px;
                height: 540px;
            }
        </style>    
        <object 
        class="resize-frame"
        id="chatbot_object"
        data="${origin}/#/aichatbot/admin/{#LOCAL_EMAIL}/${localStorage.getItem('adminChatauthToken')}" type=""></object>
    </div>`
    );
    setChatwrapper(
      `<div id="chatbot_div" class="frame-container resize-frame">
      <style>
          .frame-container {
              position: fixed;
              bottom: -30px;
              right: -25px;
              background: transparent !important;
          }
  
          .resize-frame {
              width: 120px;
              height: 120px;
              background: transparent !important;
          }
  
          .resize-frame:hover {
              width: 380px;
              height: 540px;
              background: transparent !important;
          }
      </style>    
      <object 
      class="resize-frame"
      id="chatbot_object"
      data="${origin}/#/aichatbot/userchat/{#LOCAL_EMAIL}/${localStorage.getItem('chatauthToken')}" type=""></object>
  </div>`
    );
  }, []);
  const copyIntoClipboard = (data) => {
    navigator.clipboard.writeText(data);
  };
  return (
    <Grid container spacing={2} sx={{ textAlign: 'left' }}>
      <Grid item xs={12}>
        <Typography variant="h5" sx={{ color: 'white', fontWeight: '600' }}>
          Welcome{' '}
        </Typography>
      </Grid>
      <Grid container spacing={2} item sx={{ float: 'left', flexDirection: 'row', backgroundColor: '#434343', margin: '10px' }} xs={12}>
        <Grid item xs={12}>
          <Typography variant="h6" style={{ color: '#e41645', fontWeight: '500' }}>
            Add AiChatbot Wrapper For Admins
          </Typography>
        </Grid>
        <Grid
          container
          item
          xs={10}
          spacing={2}
          sx={{
            background: '#3c3c3c',
            margin: '10px',
            paddingY: '20px',
            paddingX: '10px'
          }}
        >
          <Grid item xs={8}>
            <Typography
              variant="h9"
              xs={8}
              sx={{ wordWrap: 'break-word', color: 'white' }}
              fontFamily={'Fira Code, Consolas, Input, DejaVu Sans Mono'}
            >
              {adminWrapper}
            </Typography>
          </Grid>
          <Grid item xs={4}>
            <Icon
              sx={{ float: 'right', cursor: 'pointer', lineHeight: '20px', color: 'white' }}
              onClick={() => {
                copyIntoClipboard(adminWrapper);
              }}
            >
              <ContentCopyIcon id="icon-1" />
              <Typography id="tooltip-1" style={{ color: 'white' }}>
                Copy to clipboard.
              </Typography>
            </Icon>
          </Grid>
        </Grid>
      </Grid>
      <Grid container spacing={2} item sx={{ float: 'left', flexDirection: 'row', backgroundColor: '#434343', margin: '10px' }} xs={12}>
        <Grid item xs={12}>
          <Typography variant="h6" style={{ color: '#e41645', fontWeight: '500' }}>
            Add AiChatbot Wrapper Only For Chat
          </Typography>
        </Grid>
        <Grid
          container
          item
          xs={10}
          spacing={2}
          sx={{
            backgroundColor: '#3c3c3c',
            margin: '10px',
            paddingY: '20px',
            paddingX: '10px'
          }}
        >
          <Grid item xs={8}>
            <Typography
              variant="h9"
              xs={8}
              sx={{ wordWrap: 'break-word', color: 'white' }}
              fontFamily={'Fira Code, Consolas, Input, DejaVu Sans Mono'}
            >
              {chatWrapper}
            </Typography>
          </Grid>
          <Grid item xs={4}>
            <Icon
              sx={{ float: 'right', cursor: 'pointer', lineHeight: '20px', color: 'white' }}
              onClick={() => {
                copyIntoClipboard(chatWrapper);
              }}
            >
              <ContentCopyIcon id="icon-2" />
              <Typography id="tooltip-2" style={{ color: 'white' }}>
                Copy to clipboard.
              </Typography>
            </Icon>
          </Grid>
        </Grid>
        {/* <div
          style={{
            padding: '16px',
            backgroundColor: '#ffe6e6',
            fontFamily: 'Arial, sans-serif',
            margin: '10px'
          }}
        >
          <h3
            style={{
              margin: '0',
              color: '#cc0000'
            }}
          >
            ⚠️ Warning ⚠️
          </h3>
          <p
            style={{
              margin: '8px 0'
            }}
          >
            The code above contains <strong>sensitive tokens</strong>.
          </p>
          <p
            style={{
              margin: '8px 0'
            }}
          >
            <strong>Do not share them with anyone</strong> to ensure security and privacy.
          </p>
        </div> */}
      </Grid>
      <Grid container spacing={2} sx={{ marginTop: '30px' }} item xs={12}>
        <div
          style={{
            padding: '16px',
            backgroundColor: '#ffe6e6',
            fontFamily: 'Arial, sans-serif',
            margin: '10px'
          }}
        >
          <h3
            style={{
              margin: '0',
              color: '#cc0000'
            }}
          >
            ⚠️ Warning ⚠️
          </h3>
          <p
            style={{
              margin: '8px 0'
            }}
          >
            The code above contains <strong>sensitive tokens</strong>.
          </p>
          <p
            style={{
              margin: '8px 0'
            }}
          >
            <strong>Do not share them with anyone</strong> to ensure security and privacy.
          </p>
        </div>
      </Grid>
    </Grid>
  );
}
